(function(){
  const div = document.querySelector('.js-contacts-map');
  if(!div) return;
  const API_KEY = 'AIzaSyCFQSuje5-Q4vZcXPinD7aQxExGsHI1mSk';
  const script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&callback=_initMap`;
  script.defer = true;
  script.async = true;
  
  window._initMap = function() {
    const map = new google.maps.Map(div, {
      center: { lat: 54.679314, lng: 25.277551 },
      zoom: 17,
      mapTypeControl: !1,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: google.maps.ControlPosition.LEFT_BOTTOM
      },
      zoomControlOptions: {
        position: google.maps.ControlPosition.LEFT_TOP
      },
      scaleControl: !0,
      streetViewControl: !0,
      streetViewControlOptions: {
        position: google.maps.ControlPosition.LEFT_BOTTOM
      },
      gestureHandling: "greedy",
      scrollwheel: !1
    });
    const marker = new google.maps.Marker({
      position: { lat: 54.679314, lng: 25.277551 },
      icon: '/wp-content/themes/mo/assets/img/map-pin.svg', 
      map
    });
  };
  
  document.head.appendChild(script);
})();
